export const timelineData = [
    {
      date: "May 21, 2024",
      content: `Securin discovers the vulnerability in Follett School Solutions Destiny Library Manager version 21.2.0 RC2.`,
    },
    {
      date: "July 01, 2024",
      content: `Securin reports the vulnerability to Follett...`,
    },
    {
      date: "July 08, 2024",
      content: `Follett acknowledges the issue and reports...`,
    },
    {
      date: "July 29, 2024",
      content: `Follett shares that the official fix will be included...`,
    },
    {
      date: "August 16, 2024",
      content: `Follett releases an official fix for the vulnerability.`,
    },
    {
        date: "May 21, 2024",
        content: `Securin discovers the vulnerability in Follett School Solutions Destiny Library Manager version 21.2.0 RC2.`,
      },
      {
        date: "July 01, 2024",
        content: `Securin reports the vulnerability to Follett...`,
      },
      {
        date: "July 08, 2024",
        content: `Follett acknowledges the issue and reports...`,
      },
      {
        date: "July 29, 2024",
        content: `Follett shares that the official fix will be included...`,
      },
      {
        date: "August 16, 2024",
        content: `Follett releases an official fix for the vulnerability.`,
      },
  ];
  